import platformUtilities from '../../modules/platform_utilities.js';

angular.module('vastdesk')
.component('creativeFileUploader', {
  bindings: {
    formName: '@',
    formId: '@',
    fieldLabel: '@',
    fieldName: '@',
    tooltipText: '@',
    creativeAction: '@',
    creativeRemoteUrl: '@',
    custom: '<',
    customCode: '@',
    width: '<',
    height: '<',
    sizes: '<',
    required: '<',
    includeCustom: '<',
    customCodeLabel: '@',
    customCodeTooltip: '@'
  },
  template: require("../templates/creativeFileUploader.html"),
  controllerAs: '$creativeFileUploaderCtrl',
  controller: ['$scope', '$element', function($scope, $element) {
    var self = this;
    var defaultFileSelectedText = 'No file chosen';
    this.fileSelected = defaultFileSelectedText;

    this.creativeOptions = [
      {value: 'file', label: 'File'},
      {value: 'url', label: 'URL'}
    ];

    this.creativeOptionTooltip = function(val) {
      if (val === 'url') {
        return self.tooltipText;
      }
    };

    this.onSizeChange = function() {
      if (self.selectedSize) {
        self.width = self.selectedSize.width;
        self.height = self.selectedSize.height;
      }
    };

    this.$onInit = function() {
      if (self.customCode) {
        self.decodedCustomCode = platformUtilities.decodeMacroBraces(self.customCode);
      }

      if (self.customCodeTooltip) {
        self.decodedCustomCodeTooltip = platformUtilities.decodeMacroBraces(self.customCodeTooltip);
      }

      if (self.includeCustom) {
        self.creativeOptions.push({value: 'custom', label: 'Custom'});
      }

      if (self.sizes && self.sizes.length && self.width && self.height) {
        self.selectedSize = self.sizes.find(function(s) {
          return s.width == self.width && s.height == self.height;
        });
      }
    };

    $element.find('input[type="file"]').on('change', function() {
      if (this.files[0] && this.files[0].size > 500000000) {
        self.fileSelected = defaultFileSelectedText;
        self.errorMessage = 'File is too large';
        $('#' + self.formName  + '_' + self.fieldName).val('');
      }
      else {
        self.fileSelected = 'File selected!';
        self.errorMessage = null;
      }

      $scope.$apply();
    });
  }]
});
